import { computed, Ref } from 'vue';
import { SurveyQuestion, SurveySubmissionAnswer, SurveyAnswerType } from '@studyportals/sp-lurch-interface';

export default class ReviewUploadModalQuestionComponent {

	public isAnswerTypeMultiSelect = computed((): boolean => {
		return this.question.value.answerType === SurveyAnswerType.MULTISELECT;
	});

	public isAnswerTypeNumber = computed((): boolean => {
		return this.question.value.answerType === SurveyAnswerType.NUMBER;
	});

	constructor(
		private emit: (name: string, answer: SurveySubmissionAnswer) => void,
		public question: Ref<SurveyQuestion>,
		public answer: Ref<SurveySubmissionAnswer | undefined>
	) { }

	public storeQuestionAnswer(optionId: string | null, answerText: string | null): void {
		this.emit('questionAnswered', {
			questionId: this.question.value.questionId,
			optionId,
			answerText
		} as SurveySubmissionAnswer);
	}

	public storeQuestionAnswerNumber(element: HTMLInputElement): void {
		this.storeQuestionAnswer(
			null,
			element.value === '' ? null : element.value
		);
	}
}
